import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.1.2_@biomejs+biome@2.2.2_@capacitor+preferences@7.0.2_@capacitor+core@7.3.0__@pa_6f92e3d1a35919dae73eb08ec212fd14/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}